<template>
  <Text variant="small" text-bluish-softer text-center w-full my-4>
    Loading...
  </Text>
</template>
